import { render, staticRenderFns } from "./inner-page.vue?vue&type=template&id=21391af2&scoped=true&"
import script from "./inner-page.vue?vue&type=script&lang=js&"
export * from "./inner-page.vue?vue&type=script&lang=js&"
import style0 from "./inner-page.vue?vue&type=style&index=0&id=21391af2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21391af2",
  null
  
)

export default component.exports